// extracted by mini-css-extract-plugin
module.exports = {"container":"Ir1AO","button":"_2zTFu","icon":"_1zpkB","text":"_1EpxL","title":"_2eYYD","info":"_2DEqc","newFeature":"_1q8LT"};